import { parseEther, parseUnits, WalletClient } from "viem";

import { GetContractResult, waitForTransaction } from "wagmi/actions";
import { wrappedTokenABI } from "./wrappedTokenABI";

export const handleConvert = async ({
  contract,
  balance,
  amount,
  parse = true,
}: {
  contract: GetContractResult<typeof wrappedTokenABI, WalletClient>;
  balance: any;
  amount: string;
  parse?: boolean;
}) => {
  try {
    const diff = balanceDifference({ balance, amount, parse });

    if (diff && 0 > Number(diff)) {
      const tx = await contract.write.deposit({
        value: Math.abs(diff).toString(),
      });

      await waitForTransaction({ hash: tx });
    }
  } catch (err) {
    throw err;
  }
};

const balanceDifference = ({ balance, amount, parse }) => {
  try {
    if (!amount || !balance) return 0;
    return Number(
      balance?.value - BigInt(parse ? parseUnits(amount, 18) : amount)
    );
  } catch (err) {
    console.log(err);
  }
};
